import { render, staticRenderFns } from "./SurgeryMenu.vue?vue&type=template&id=610c8f68"
import script from "./SurgeryMenu.vue?vue&type=script&lang=js"
export * from "./SurgeryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports